// import collapsibleHandler from './collapsible';
import smoothscroll from 'smoothscroll-polyfill';
import injectRegistrationScripts, { injectDefaultScripts } from './registrationScripts';

/**
   * Polyfill for parents method
   * @param {*} selector
   */
function parents(selector) {
  const elements = [];
  let elem = this;
  const isHaveSelector = selector !== undefined;
    while ((elem = elem.parentElement) !== null) { //eslint-disable-line
    if (elem && elem.nodeType !== window.Node.ELEMENT_NODE) {
      continue; //eslint-disable-line
    }

    if (!isHaveSelector || (elem && elem.matches(selector))) {
      elements.push(elem);
    }
  }

  return elements;
}

let smoothScrollPolyfillFlag = 0;
function smoothScrollSection() {
  smoothscroll.polyfill();
  smoothScrollPolyfillFlag = 1;
  const scrollTrigger = document.querySelector('.js-scroll-section');
  const scrollTarget = scrollTrigger.getAttribute('href');
  scrollTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector(scrollTarget).scrollIntoView({ behavior: 'smooth' });
  });
}

function collapsibleScrollHandler() {
  if (!smoothScrollPolyfillFlag) smoothscroll.polyfill();
  const collapsibleTrigger = document.querySelector('#collapsibleTrigger');
  const collapsibleClose = document.querySelector('#collapsibleClose');
  const collapsibleSection = document.querySelector('.js-collapsible-scroll');

  const scrollIntoView = (scrollTrigger) => {
    const scrollTarget = scrollTrigger.getAttribute('href');
    document.querySelector(scrollTarget).scrollIntoView({ behavior: 'smooth' });
  };

  collapsibleTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    scrollIntoView(collapsibleTrigger);
    collapsibleSection.style.maxHeight = '1100px';
    collapsibleTrigger.parentElement.classList.add('is-open');
  });

  collapsibleClose.addEventListener('click', (e) => {
    e.preventDefault();
    scrollIntoView(collapsibleClose);
    collapsibleSection.style.maxHeight = '0px';
    collapsibleTrigger.parentElement.classList.remove('is-open');
  });
}

window.Element.prototype.parents = parents;

function navTabHandler() {
  const navTabs = document.querySelectorAll('.nav-tabs>li');
  navTabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const navSectionId = tab.dataset.navSection;
      const activePlanTable = document.querySelector('.larger-plans-table.active');
      if (activePlanTable) {
        activePlanTable.classList.remove('active');
        document.querySelector('.nav-tabs>li.active').classList.remove('active');
      }
      tab.classList.add('active');
      document.getElementById(navSectionId).classList.add('active');
    });
  });
}


function accordionHandler() {
  const accordion = document.querySelectorAll('.js-accordion');
  if (accordion) {
    accordion.forEach((accordionEl) => {
      const accordionToggle = accordionEl.querySelectorAll('.js-accordion-toggle');
      accordionToggle.forEach((el) => {
        el.addEventListener('click', () => {
          const targetItem = el.parentElement;
          const targetContent = targetItem.querySelector('.js-accordion-content');
          if (targetItem.classList.contains('open')) {
            targetItem.classList.remove('open');
            targetContent.style.maxHeight = '0px';
          } else {
            const accordionOpen = accordionEl.querySelector('li.open');
            if (accordionOpen) {
              accordionOpen.classList.remove('open');
              accordionOpen.querySelector('.js-accordion-content').style.maxHeight = '0px';
            }
            targetItem.classList.add('open');
            targetContent.style.maxHeight = `${targetContent.scrollHeight}px`;
          }
        });
      });
    });
  }
}

function animateLogo() {
  const logo = document.querySelector('.ac-logo');
  if (logo) {
    setTimeout(() => {
      logo.classList.remove('logo-animate');
    }, 2000);
  }
}

function injectOnView() {
  if (window.pageYOffset >= 300) {
    injectRegistrationScripts();
    injectDefaultScripts();
  }
}

injectOnView();

window.addEventListener('scroll', injectOnView);

window.addEventListener('load', () => {
  animateLogo();
  accordionHandler();
  if (window.innerWidth > 992) navTabHandler();
  if (document.querySelector('.js-scroll-section')) smoothScrollSection();
  if (document.querySelector('#collapsibleTrigger')) collapsibleScrollHandler();
});
